import { Component } from '@angular/core';

@Component({
  selector: 'uni-title-container',
  templateUrl: './uni-title-container.component.html',
  styleUrls: ['./uni-title-container.component.scss'],
})
export class UniTitleContainerComponent {}
